import { render, staticRenderFns } from "./ProfileGuardian.vue?vue&type=template&id=1284b139&scoped=true&"
import script from "./ProfileGuardian.vue?vue&type=script&lang=ts&"
export * from "./ProfileGuardian.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileGuardian.vue?vue&type=style&index=0&id=1284b139&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284b139",
  null
  
)

export default component.exports